import { LoadingPageSpinner } from '../../../../shared/components/LoadingPageSpinner';

export function LoadingObjects() {
  return (
    <LoadingPageSpinner
      className='h-100'
      title='Fetching Objects'
      subtitle='Hang on while we fetch the objects from your Source. It may take a while based on how many
        objects there are in the Source.'
      showElapsedTime
    />
  );
}
